/**
 * Состав пака «framed-center» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 21 воронок: группы.json, группы 2 (PACK в matrix.py)
  palettes: [
    // 4 из 21 воронок: palette → ближайшая тема по цветам
    { themeId: 'ember-dark', weight: 0.19 },
    // 2 из 21 воронок: palette → ближайшая тема по цветам
    { themeId: 'rose-blush', weight: 0.1 },
    // 2 из 21 воронок: palette → ближайшая тема по цветам
    { themeId: 'blue-gradient-light', weight: 0.1 },
  ],
  fonts: [
    // 16 из 21 воронок: fontId
    { fontId: 'inter', weight: 0.76 },
  ],
  screenKinds: [
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.398; сюда свёрнуты Q10, Q6, Q9 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.46 },
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.099; сюда свёрнуты I2 (замена из arsenal.mjs)
    { kind: 'I1', share: 0.11 },
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.093; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.11 },
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.088; сюда свёрнуты Q11, Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.1 },
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.078
    { kind: 'N1', share: 0.09 },
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.044
    { kind: 'N2', share: 0.05 },
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.039
    { kind: 'N5', share: 0.05 },
    // средняя доля экранов по 21 воронкам (признаки.json kinds) 0.031
    { kind: 'N4', share: 0.04 },
  ],
  blocks: [
    // в 18 из 21 воронок (признаки.json blocks), подъём 1.90; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): optionIndicator 46 из 88
    {
      type: 'multiple_choice',
      weight: 0.86,
      settings: { optionIndicator: 'auto' },
    },
    // в 21 из 21 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 262 из 286, optionIndicator 274 из 286
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 13 из 21 воронок (признаки.json blocks), подъём 2.75; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 30 из 30
    { type: 'image_choice', weight: 0.62, settings: { autoAdvance: true } },
    // в 14 из 21 воронок (признаки.json blocks), подъём 1.39
    { type: 'loader_processing', weight: 0.67, settings: {} },
    // в 5 из 21 воронок (признаки.json blocks), подъём 3.59
    { type: 'number_input', weight: 0.24, settings: {} },
    // в 7 из 21 воронок (признаки.json blocks), подъём 2.18; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): unitPickerLook 6 из 7, unitToggleLook 6 из 7, unitTogglePosition 6 из 7
    {
      type: 'height_picker',
      weight: 0.33,
      settings: {
        unitPickerLook: 'big-number',
        unitToggleLook: 'pill',
        unitTogglePosition: 'above',
      },
    },
    // в 7 из 21 воронок (признаки.json blocks), подъём 2.18; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): unitPickerLook 14 из 18, unitToggleLook 12 из 18, unitTogglePosition 12 из 18
    {
      type: 'weight_picker',
      weight: 0.33,
      settings: {
        unitPickerLook: 'big-number',
        unitToggleLook: 'pill',
        unitTogglePosition: 'above',
      },
    },
  ],
  niches: [
    // 8 из 21 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.38 },
    // 3 из 21 воронок (признаки.json theme)
    { niche: 'education', weight: 0.14 },
    // 2 из 21 воронок (признаки.json theme)
    { niche: 'parenting', weight: 0.1 },
    // 2 из 21 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.1 },
  ],
};
